/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { StaticDomainConfiguration } from '../../../../../../../page-frame-types/StaticDomainConfiguration';
import { useSVGImageState } from './hooks/useSVGImageState';

export enum SVG_IMAGE_LOADING_METHOD {
    EAGER = 'eager',
    LAZY = 'lazy',
}

export enum SVG_IMAGE_DECODING_METHOD {
    AUTO = 'auto',
    SYNC = 'sync',
    ASYNC = 'async',
}

const ZillowPageFrameImage = styled.img``;

export type SvgImageProps = {
    /**
     * Which logo to render
     */
    svgFileName?: string;
    /**
     * Used for setting the alt value for the logo
     */
    svgName?: string;
    /**
     * Used for determing which CDN to use
     */
    staticDomain: StaticDomainConfiguration;
    title?: string;
    /**
     * Configures the loading of the image behavior
     */
    loading?: SVG_IMAGE_LOADING_METHOD;
    /**
     * Configures the decoding of the image behavior
     */
    decoding?: SVG_IMAGE_DECODING_METHOD;
};
export const ZillowSVGImage: FunctionComponent<SvgImageProps> = ({
    svgFileName,
    svgName,
    staticDomain,
    title,
    loading = SVG_IMAGE_LOADING_METHOD.EAGER,
    decoding = SVG_IMAGE_DECODING_METHOD.AUTO,
    ...rest
}) => {
    const { basePath } = useSVGImageState(staticDomain);

    return (
        // eslint-disable-next-line @next/next/no-img-element
        <ZillowPageFrameImage
            {...rest}
            src={`${basePath}/pfs/static/${svgFileName}.svg`}
            // @ts-ignore
            type="image/svg+xml"
            alt={svgName}
            focusable={false}
            title={title}
            loading={loading}
            decoding={decoding}
        />
    );
};
